import React, { useEffect, useState } from "react";
import Cleave from "cleave.js/react";
import error from "../autorizacaoGuias/images/archive.png";

const DeclaracaoImpostoDeRendaCPP = (props) => {
  const [loading, setLoading] = useState(false);
   // eslint-disable-next-line
  const [didError, setDidError] = useState(false);
  const [errors, setErrors] = useState([]);
  const [cpf, setCpf] = useState("");
  const [ano, setAno] = useState("");
   // eslint-disable-next-line
  const [response, setResponse] = useState("");

  useEffect(() => {
    window.parent.postMessage('change', window.location.origin)
  });


  const validateForm = () => {
    const errors = [];
    if (cpf.length === 0) {
      errors.push({ field: "cpf", message: "Preencha seu CPF" });
    } else {
      if (cpf.length !== 11) {
        errors.push({ field: "cpf", message: "Verifique seu CPF" });
      }
    }
    if (ano.length === 0) {
      errors.push({
        field: "ano",
        message: "Preencha o Ano Base"
      });
    } else {
      if (ano.length !== 4) {
        errors.push({
          field: "ano",
          message: "Verifique o Ano Base"
        });
      }      
    }
    setErrors(errors);
    return errors.length;
  };

  const onSendForm = async (e) => {

    e.preventDefault(); // Evitar o comportamento padrão de submissão do formulário

    if (validateForm()) {
      return;
    }
    setLoading(true);

    e.currentTarget.submit(); // Envia o formulário se a validação passar

    setLoading(false);
    
    setErrors(errors);
  };

  const renderValidation = field => {
    const error = errors.find(e => e.field === field);
    if (!error) {
      return null;
    }
    return <div className="validation-message">{error.message}</div>;
  };

  const renderError = () => {
    if (didError) {
      return (
        <div className="not-found-wrapper">
          <img src={error} alt="Erro" />
          <h5>Ocorreu um erro</h5>
          <p>
            Um erro ocorreu ao processar sua consulta. Por favor tente
            novamente.
          </p>
          <p>
            Se esta mensagem for recorrente, entre em contato com o suporte.
          </p>
        </div>
      );
    }
    return null;
  };

  const renderLoading = () => {
    if (loading) {
      return (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      );
    }
  };

  return (
    <section
      className={`consulta-copart txt8 lh-1 ${props.hide ? "hide" : ""}`}
    >
      <h2 className="txt-laranja">
        Informe de Rendimentos para fins de Imposto de Renda CPP
      </h2>
      <p>Esta opção está disponível para clientes de Plano Familiar.</p>
      <h3 className="txt-verde">
        Preencha os dados abaixo e clique em "Imprimir":
      </h3>
      <div className="box-passos">
      <form action="https://portaldocliente.unimedvs.com.br/declaracaoircpp" method="post" onSubmit={onSendForm} target="_blank">
        <div className="linha-form">
          <div>Ano Base</div>
          <div>
            {" "}
            <Cleave
              type={"ontouchstart" in document.documentElement ? "tel" : "text"}
              id="ano"
              name="ano"
              value={ano}
              options={{
                blocks: [4],
                delimiter: " ",
                numericOnly: true
              }}
              onChange={(e)=>setAno(e.target.rawValue)}
            />
            {renderValidation("ano")}
          </div>
        </div>
        <div className="linha-form">
          <div>CPF do cliente</div>
          <div>
            {" "}
            <Cleave
              type={"ontouchstart" in document.documentElement ? "tel" : "text"}
              id="cpf"
              name="cpf"
              value={cpf}
              options={{
                blocks: [3, 3, 3, 2],
                delimiters: [".", ".", "-"],
                numericOnly: true
              }}
              onChange={(e)=>setCpf(e.target.rawValue)}
            />
            {renderValidation("cpf")}
          </div>
        </div>
        <div className="linha-form">
              <div></div>
        <div>
        <button className="btn">
          Imprimir
        </button>
        </div>
        </div>
        {renderLoading()}
        <div dangerouslySetInnerHTML={{__html: response}}></div>
        {renderError()}
        </form>
      </div>
    </section>
  );
};

export default DeclaracaoImpostoDeRendaCPP;
